import React from 'react';
import { ScanLabelConnectorApollo, withMobileAppMode } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerScanLabelAnalyzingContainer from './TrackerScanLabelAnalyzingContainer';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';
import { hasAnyPaidAccess } from '../helpers';

const TrackerScanLabelAnalyzingPage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();

  // Same gate as the scanner route it is reached from (TrackerScanLabelPage) — this route issues the
  // paid `scanLabel` mutation itself, so it cannot rely on the previous screen having checked.
  if (hasAnyPaidAccess() || mobileAppMode) {
    return (
      <ScanLabelConnectorApollo>
        {({ scanLabel, cancelScanLabel }) => (
          <TrackerScanLabelAnalyzingContainer
            key={location.key}
            scanLabel={scanLabel}
            cancelScanLabel={cancelScanLabel}
          />
        )}
      </ScanLabelConnectorApollo>
    );
  }

  // The scanner is behind us in the history stack, so offer a way back to it.
  return <TrackerNoAccess showBackBtn={true} />;
};

export default withMobileAppMode(TrackerScanLabelAnalyzingPage);
